import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import ReactAudioPlayer from 'react-audio-player';
import styles from './index.module.less';

export default function VoiceCard({url}) {
    const voiceRef = useRef();
    return (
        <div
            className={styles.container}
            onClick={() => {
                voiceRef.current.audioEl.current.play();
            }}
        >
            <img src={require('@/asset/voice-icon.png').default} />
            <ReactAudioPlayer src={url} ref={voiceRef} />
        </div>
    );
}

VoiceCard.propTypes = {
    url: PropTypes.string,
};
